import { Dispatch, SetStateAction, useEffect } from "react";
import MegaMenu from "../mega-menu";
import { Portal } from "@headlessui/react";
import IconlyCategoryIcon from "@svg/new-design/bottom-tab-navigation/CategoryIcon";
import { useRouter } from "next/router";
import classNames from "classnames";
import { IMegamenuInput } from "features/home/helpers/types";

interface Props {
  megamenu?: IMegamenuInput;
  showMegaMenu: boolean;
  setShowMegaMenu: Dispatch<SetStateAction<boolean>>;
}
const MegaMenuPopover: React.FC<Props> = ({
  megamenu,
  showMegaMenu,
  setShowMegaMenu,
}) => {
  const { pathname } = useRouter();

  const handleEnter = () => {
    setShowMegaMenu(true);
  };

  const handleLeave = () => {
    setShowMegaMenu(false);
  };

  useEffect(() => {
    setShowMegaMenu(false);
  }, [pathname]);

  const handleClick = () => {
    setShowMegaMenu((prev) => !prev);
  };

  return (
    <>
      <div
        className="relative hidden md:flex h-fds-60 flex-nowrap whitespace-nowrap rounded-lg cursor-auto"
        onMouseLeave={handleLeave}
      >
        <div
          onClick={handleClick}
          onMouseEnter={handleEnter}
          className="hidden md:flex px-3 text-sm font-normal leading-7 text-[#27272A] outline-none cursor-pointer items-center gap-2"
        >
          <IconlyCategoryIcon width={16} height={16} />
          دسته‌بندی‌ها{" "}
        </div>
        <div
          className={classNames(
            "absolute top-fds-60 transition-opacity duration-300",
            showMegaMenu
              ? "z-[49] opacity-100"
              : "z-[-100] opacity-0 pointer-events-none"
          )}
        >
          <MegaMenu megamenu={megamenu} />
        </div>
      </div>
      <Portal>
        <div
          className={classNames(
            showMegaMenu
              ? "z-[49] opacity-100"
              : "z-[-100] opacity-0 pointer-events-none",
            "top-0 left-0 fixed w-screen h-screen overflow-hidden bg-[rgba(0,0,0,.5)] transition-opacity duration-300"
          )}
        />
      </Portal>
    </>
  );
};

export default MegaMenuPopover;
